import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Container,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Cookies from 'js-cookie'

import {
  FaCopy,
  FaEye,
  FaSyncAlt,
} from 'react-icons/fa'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

import toast from 'react-hot-toast'
import { Eye,  Person } from 'react-bootstrap-icons'
import { FaEyeSlash } from 'react-icons/fa'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'

const AddUser = () => {
  const { user, token } = useAuth()
  console.log('USER ', user)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(20)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [allInstitute, setAllInstitute] = useState([])
  const [createdPassword, setCreatedPassword] = useState('');
  const [showCreatedPassword, setShowCreatedPassword] = useState(false);

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {

        // const userCookie = Cookies.get('user')
        //  let token = null

        //  if(userCookie){
        //    token = user.token
        //  }

        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        // console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL + '/get/users',
          { headers },
        )

        console.log('Users response: ', response.data)

        setData(response.data)
        // setFilteredData(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [loading])
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    password: '',
    institute_id: '',
    user_id: '',
    user_type: '',
  })


  // Filter Data Based on Search
  const filteredData = data?.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
const totalPages = Math.ceil((filteredData?.length || 0) / itemsPerPage) || 1
 useEffect(() => {
  if (currentPage > totalPages && totalPages !== 0) {
    setCurrentPage(1)
  }
}, [filteredData, totalPages])


const indexOfLastItem = currentPage * itemsPerPage
const indexOfFirstItem = Math.max(indexOfLastItem - itemsPerPage, 0)
const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem) || []


// Fetch institutes
useEffect(() => {
  const fetchInstitutes = async () => {
    try {
      const res = await ApiEndpoints.getAllInstitutes()
      setAllInstitute(res.data.data)
    } catch (error) {
      console.error(error)
    }
  }
  fetchInstitutes()
}, [])

const handleInputChange = (e) => {
  const { name, value } = e.target;
   setNewUser((prev) => ({
    ...prev,
    [name]: value,
  }))
};

  // Add New Teacher
  const handleSave = async (e) => {
    e.preventDefault()

    try {
      setLoading(true)
    
      // const headers = {
      //   Authorization: `Bearer ${user.token}`,
      // }
      const payload = {
      name:  newUser.name,
      email:  newUser.email,
      password:  newUser.password,
      institute_id: Number(newUser.institute_id),
      user_id:  newUser.user_id || null,
      user_type:  newUser.user_type,
        // headers,
      }

      console.log('Sending data: ', newUser)
      const response = await axios.post(BASE_URL + "/create/user",payload,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      toast.success(response.data.message)
      
    // Store the created password so we can show it
    setCreatedPassword(newUser.password);
      setNewUser({
        name: '',
        email: '',
        password: '',
        institute_id: '',
        user_id: '',
        user_type: '',
      })
      // setTeacherImage(null)
      setShowModal(false)
    } catch (error) {
       // ✅ Handle validation & other API errors
    if (error.response?.data?.errors) {
      // Loop through all validation messages
      const allErrors = error.response.data.errors;
      Object.values(allErrors).forEach((errArr) => {
        errArr.forEach((msg) => toast.error(msg));
      });
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Something went wrong. Please try again.");
    }

    setShowModal(true);

    } finally {
      setLoading(false)
    }
  }

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const navigate = useNavigate()
  const assignUserRole = (item) => {
    navigate(`/Assign/UserRole/${item.id}`, {
      state: {
        userData: {
          id: item.id,
          name: item.name,
          email: item.email,
        },
      },
    });
  };

  const handleRefresh = async () => {
    setSearch({})

    setData(data)
    setSearch('')
    setCurrentPage(1)
  }

  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0 ">Users</h2>
          <Button
            variant="light"
            className="fw-bold px-4 py-2 rounded shadow-sm d-flex align-items-center"
            onClick={() => setShowModal(true)}
          >
            <Person size={18} className="me-2" />
            Add New User
          </Button>
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={3}>
          <Form.Control
            type="text"
            placeholder="Search User Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>
<div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3 mt-4">

  {/* Password Reference */}
  {createdPassword && (
    <div className="alert alert-info d-flex align-items-center justify-content-between p-2 w-100 w-md-auto order-0 mb-2 mb-md-0">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <strong>Created user password, please note:</strong>
        <input
          type="text"
          className="form-control form-control-sm"
          value={createdPassword}
          readOnly
          style={{ maxWidth: "150px" }}
        />
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => navigator.clipboard.writeText(createdPassword)}
          title="Copy Password"
        >
          <FaCopy />
        </button>
      </div>
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={() => setCreatedPassword("")}
      ></button>
    </div>
  )}

  {/* Users count & pagination */}
  <div className="d-flex align-items-center gap-3 order-1 w-100 w-md-auto justify-content-end">
    <p className="text-black m-0">Total Users: {filteredData?.length}</p>
    <Form.Select
      className="w-auto"
      value={itemsPerPage}
      onChange={(e) => {
        setItemsPerPage(parseInt(e.target.value));
        setCurrentPage(1);
      }}
    >
      <option value="20">20 per page</option>
      <option value="40">40 per page</option>
      <option value="60">60 per page</option>
    </Form.Select>
  </div>
</div>


      {/* User Table */}

 

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr>
            <Th>Name</Th>
            <Th>Email</Th>
            {/* <Th>User Type</Th> */}
            {/* <Th>User ID</Th> */}
            <Th>Institute</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems?.length > 0 ? (
            currentItems?.map((item, index) => (
              <Tr key={index} className="align-middle">
                <Td>{highlightText(item.name?.toUpperCase(), search)}</Td>
                <Td>{item.email}</Td>
                {/* <Td>{item.user_type ? item.user_type.charAt(0).toUpperCase() + item.user_type.slice(1) : ''}</Td> */}
                {/* <Td>{item.user_id || "-"}</Td> */}
                <Td>
                  {
                    allInstitute.find(inst => inst.institute_id === item.institute_id)?.name || '-'
                  }
                </Td>
                <Td className="text-center">
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                    <Button
                      variant="info"
                      className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2"
                    title='Manage Role'
                        onClick={() => assignUserRole(item)}
                    >
                      <Eye />
                    </Button>
                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan="8" className="text-center text-muted fw-bold p-4">
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      {/* Total Records */}
      <div className="d-flex justify-content-end align-items-center">
        <Pagination className="mt-2">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New User Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newUser.name}
                onChange={handleInputChange}
                placeholder="Enter User's Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* Email ID Field */}
            <Form.Group className="mb-3">
              <Form.Label>Email ID *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newUser.email}
                onChange={handleInputChange}
                placeholder="Enter Email"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>User Type *</Form.Label>
              <Form.Select
                name="user_type"
                value={newUser.user_type}
                onChange={handleInputChange}
                required
              >
                <option value="">Select</option>
                <option value="admin">Admin</option>
                {/* <option value="teacher">Teacher</option> */}
                <option value="accountant">Accountant</option>
                <option value="marketer">Marketer</option>
                {/* <option value="parents">Guardian</option> */}
              </Form.Select>
            </Form.Group>

            {/* <Form.Group className="mb-3">
              <Form.Label>User Id</Form.Label>
              <Form.Control
                type="text"
                name="user_id"
                value={newUser.user_id}
                onChange={handleInputChange}
                placeholder="Enter User ID"
                required
              />
            </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label>Institute *</Form.Label>
            <Form.Select
              name="institute_id"
              value={newUser.institute_id}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Institute</option>
              {allInstitute.map((inst) => (
                <option key={inst.institute_id} value={inst.institute_id}>
                  {inst.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>



            <Form.Group className="mb-3 mt-3">
              <Form.Label>Password *</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={newUser.password}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  className="p-2 border rounded"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  title={showPassword ? 'Hide Password' : 'Show Password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </div>
            </Form.Group>

            {/* <Form.Group className="mb-3">
              <Form.Label>User Image (PNG/JPG/JPEG)</Form.Label>

              <div className="d-flex align-items-center gap-3 mt-2 mb-2">
                <Form.Control
                  type="file"
                  accept="teacher_image/png, teacher_image/jpeg, teacher_image/jpg"
                  onChange={(e) => setTeacherImage(e.target.files[0])}
                  style={{ maxWidth: '700px' }}
                />
                {teacherImage && (
                  <img
                    src={URL.createObjectURL(teacherImage)}
                    alt="Preview"
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: 'cover',
                      borderRadius: 8,
                      border: '1px solid #ccc',
                    }}
                  />
                )}
              </div>
            </Form.Group> */}

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Save User
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AddUser
